import { getFetchArgs, providesList } from "../../utils.js";
import { mdsApi } from "../api.js";
import { MDS_URL_SEGMENTS, MDS_TAGS } from "../common.js";
const resource = MDS_URL_SEGMENTS.SYSTEM_HEALTH_BANNERS;
const mdsApiVersion = "2021-11-01-preview";
const systemHealthBannersApi = mdsApi.injectEndpoints({
  endpoints: (builder) => ({
    getSystemHealthBannerById: builder.query({
      query: (payload) => getFetchArgs({ resource, payload, apiVersion: mdsApiVersion }),
      providesTags: (result, error, { id }) => [{ type: MDS_TAGS.SYSTEM_HEALTH_BANNERS, id }]
    }),
    querySystemHealthBanners: builder.query({
      query: (payload) => getFetchArgs({ resource, payload, apiVersion: mdsApiVersion }),
      providesTags: (result) => providesList(result, MDS_TAGS.SYSTEM_HEALTH_BANNERS)
    }),
    createOrUpdateSystemHealthBanner: builder.mutation({
      query: (payload) => getFetchArgs({ resource, payload, method: "PUT", apiVersion: mdsApiVersion }),
      invalidatesTags: (result, error, { entity }, meta) => {
        var _a;
        return providesList([entity], MDS_TAGS.SYSTEM_HEALTH_BANNERS, ((_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.status) === 201);
      }
    }),
    deleteSystemHealthBanner: builder.mutation({
      query: (payload) => getFetchArgs({ resource, payload, method: "DELETE", apiVersion: mdsApiVersion }),
      invalidatesTags: (result, error, { id }) => providesList([{ id }], MDS_TAGS.SYSTEM_HEALTH_BANNERS)
    })
  })
});
const {
  usePrefetch: usePrefetchSystemHealthBanners,
  useGetSystemHealthBannerByIdQuery,
  useLazyGetSystemHealthBannerByIdQuery,
  useQuerySystemHealthBannersQuery,
  useLazyQuerySystemHealthBannersQuery,
  useCreateOrUpdateSystemHealthBannerMutation,
  useDeleteSystemHealthBannerMutation
} = systemHealthBannersApi;
export {
  systemHealthBannersApi,
  useCreateOrUpdateSystemHealthBannerMutation,
  useDeleteSystemHealthBannerMutation,
  useGetSystemHealthBannerByIdQuery,
  useLazyGetSystemHealthBannerByIdQuery,
  useLazyQuerySystemHealthBannersQuery,
  usePrefetchSystemHealthBanners,
  useQuerySystemHealthBannersQuery
};
//# sourceMappingURL=system-health-banners.js.map
